import * as React from 'react'
import onClickOutside from 'react-onclickoutside';

class ClickOutside extends React.Component {
  handleClickOutside = this.props.onExit;
  render = () => this.props.children;
}

export const ClickOutsideWrapper = onClickOutside(ClickOutside);
